<template>
  <div class="bd3Command">
    <bg-intro :bg="bg" class="bg-wrapper"></bg-intro>
    <div class="intro-section">
      <div class="content_wrapper">
        <h3>星地多网融合调度平台</h3>
        <p>
          星地多网融合调度平台实现了北斗三号短报文卫星、天通一号卫星、宽带卫星与现场终端产品的高效融合，通过定位、通信和授时、监控下属设备通信等功能来实现视频监控、物资调配、离线地图、调度指挥和语音对讲功能；局端通过本地部署实现离线地图、指令下发、指挥调度、组群指挥、电子围栏、语音对讲等，还可以根据客户需求定制指定区域离线地图，根据客户需求定制
          UI 和定制开发相关功能，特别适用于应急救援，方舱，指挥调度等需求。
        </p>
        <div class="img-wrapper">
          <img src="../../assets/pcbd3/bd3command/bd3Pro2.png" alt="" />
        </div>
        <div class="our_pro_detail">
          <a target="_blank"  href="https://www.tiandiweitong.com/integration.html">了解详情</a>
        </div>
        <product title="适用设备" :productData="productData"></product>
        <div class="notice">
          <span class="symbol">*</span>
          <span class="notice-content">支持通用的标准北斗协议终端，如需兼容请联系客服</span>
        </div>
      </div>
    </div>
    <div class="feature-section">
      <h3>功能列表</h3>
      <div class="img-wrapper">
        <img src="../../assets/pcbd3/bd3command/gnlbPro.png" alt="" />
      </div>
    </div>

    <div class="download-section content_wrapper">
      <div class="item">
        <img src="../../assets/pcbd3/bd3test/RDSS测试软件logo.png" alt="" />
        <span>申请下载测试请填写以下表单</span>
      </div>
      <!-- <a class="item" download target="_blank"
        href="https://back.openc.beidousdk.com/api/console/files/material/other/bd3-command-system-instruction-manual.pdf">
        <img src="../../assets/pcbd3/bd3test/wenjian_pdf.png" alt="" />
        <span>说明书下载</span>
      </a> -->
    </div>

    <div class="form-section">
      <h3>申请测试系统表单填写</h3>
      <div class="form-content">
        <el-form :model="form" :rules="custom" ref="custom" label-position="top">
          <el-form-item label="联系姓名" prop="fullName">
            <el-input v-model="form.fullName" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入您的单位名称"></el-input>
          </el-form-item>
          <el-form-item label="联络电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper">
          <button @click="submitCustom">提 交</button>
        </div>
      </div>
    </div>

    <div class="faq-section">
      <h3>常见问题FAQ</h3>
      <div class="faq-wrapper content_wrapper">
        <div class="faq-item">
          <div class="left-item">
            <img src="../../assets/pcbd3/bd3command/wenti.png" alt="" />
            <span>Q1</span>
          </div>
          <div class="right-item">
            <h4 class="title">是否可以本地部署？</h4>
            <p>支持程序部署到用户的物理服务器，可提供上门安装服务，并跟根据客户需求下载指定区域的离线地图。</p>
          </div>
        </div>

        <div class="faq-item">
          <div class="left-item">
            <img src="../../assets/pcbd3/bd3command/wenti.png" alt="" />
            <span>Q2</span>
          </div>
          <div class="right-item">
            <h4 class="title">如何获取测试版本？</h4>
            <p>填写下方表格或直接致电销售热线，报备公司信息即可获取测试版本。</p>
          </div>
        </div>

        <div class="faq-item">
          <div class="left-item">
            <img src="../../assets/pcbd3/bd3command/wenti.png" alt="" />
            <span>Q3</span>
          </div>
          <div class="right-item">
            <h4 class="title">是否可以接受定制和接入指定终端？</h4>
            <p>可根据客户需求进行logo图标，软件名称，界面风格等定制内容，也可根据用户要求接入指定北斗终端。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgIntro from '@/components/common/product/bgIntro.vue';
import product from '@/components/common/bd3/product.vue';
import { validatePhone, validateFullName, validateCompany } from '@/utils/validate';
import axios from 'axios';
import config from '@/config'
export default {
  name: 'bd3test',
  data() {
    return {
      bg: require('../../assets/pcbd3/bd3command/bd3Pro.png'),
      productData: [
        {
          id: 1,
          name: '北斗盒子',
          imgSrc: require('../../assets/pcbd3/bd3command/shebei1Pro.png'),
          link: 'https://www.tiandiweitong.com/pd17.html',
        },
        {
          id: 2,
          name: '北斗手持机',
          imgSrc: require('../../assets/pcbd3/bd3command/shebei2Pro.png'),
          link: 'https://www.tiandiweitong.com/pd20.html',
        },
        {
          id: 3,
          name: '北斗车载终端',
          imgSrc: require('../../assets/pcbd3/bd3command/shebei3Pro.png'),
          link: 'https://www.tiandiweitong.com/td30.html',
        },
        {
          id: 4,
          name: '北斗对讲机',
          imgSrc: require('../../assets/pcbd3/bd3command/shebei4Pro.png'),
          link: 'https://www.tiandiweitong.com/td70.html',
        },
        {
          id: 5,
          name: '北斗消防头盔',
          imgSrc: require('../../assets/pcbd3/bd3command/shebei5Pro.png'),
          link: 'https://www.tiandiweitong.com/',
        },
        {
          id: 6,
          name: '智能手环',
          imgSrc: require('../../assets/pcbd3/bd3command/shebei6Pro.png'),
          link: 'https://www.tiandiweitong.com/pw02.html',
        },

      ],
      form: {
        fullName: '',
        phone: '',
        companyName: '',
      },
      custom: {
        fullName: [{ required: true, trigger: 'blur', validator: validateFullName }],
        companyName: [{ required: true, trigger: 'blur', validator: validateCompany }],
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
      },
    };
  },
  components: {
    bgIntro,
    product,
  },
  methods: {
    submitCustom() {
      this.$refs.custom.validate(async (valid) => {
        if (valid) {
          try {
            const res = await axios({
              baseURL: config.baseUrl,
              url: '/api/console/forms/bd3-command-system-application',
              method: 'post',
              params: {
                Authorization: '1213',
                ...this.form,
              },
            });
            console.log(res);
            if (res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '提交成功',
              });
              this.reload();
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bd3Command {
  width: 100%;

  .intro-section {
    width: 100%;
    background-color: #f6f7f8;
    padding: 40px 0px;

    h3 {
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0d0e24;
      line-height: 30px;
      text-align: center;
      margin-bottom: 45px;
    }

    p {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 400;
      color: #0d0e24;
      line-height: 32px;
    }

    .img-wrapper {
      margin-top: 45px;
      text-align: center;
      // width: 1200px;
    }

    .notice {
      margin: 24px 0px;
      display: flex;
      justify-content: center;
      align-items: center;

      .symbol {
        font-size: 14px;
        font-weight: 300;
        color: #ef5252;
        line-height: 30px;
      }

      .notice-content {
        font-size: 14px;
        font-weight: 300;
        color: #6e6e66;
        line-height: 30px;
      }
    }
  }

  .feature-section {
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #000000;
      text-align: center;
      margin: 48px 0px;
    }

    .img-wrapper {
      text-align: center;
    }
  }

  .download-section {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 70px;

    .item {
      display: inline-block;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      text-decoration: none;

      span {
        display: inline-block;
        white-space: nowrap;
        font-size: 20px;
        font-weight: 400;
        color: #db251f;
        line-height: 45px;
      }
    }
  }

  .form-section {
    padding: 70px 0;
    background: #f6f7f8;

    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-bottom: 50px;
    }

    .form-content {
      width: 800px;
      margin: 0 auto;

      &::v-deep {
        .el-form-item__label {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }

      .btn-wrapper {
        text-align: left;
        margin-top: 60px;
        margin-bottom: 60px;

        button {
          width: 256px;
          height: 46px;
          background: #4173fb;
          border-radius: 4px;
          cursor: pointer;
          outline: none;
          border: none;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }

  .faq-section {
    padding: 70px 0;

    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-bottom: 50px;
    }

    .faq-wrapper {
      .faq-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-bottom: 40px;

        .left-item {
          width: 35px;
          height: 35px;
          position: relative;
          margin-right: 12px;

          img {
            position: absolute;
          }

          span {
            font-size: 13px;
            font-weight: 400;
            color: #ffffff;
            color: #fff;
            position: absolute;
            top: 5px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        .right-item {
          .title {
            font-size: 18px;
            font-weight: 400;
            color: #333333;
          }

          p {
            margin-top: 10px;
            font-size: 18px;
            font-weight: 300;
            color: #666666;
            line-height: 35px;
          }
        }
      }
    }
  }
}

.right90 {
  margin-right: 90px;
}

.reverse {
  flex-direction: row-reverse;
}

.our_pro_detail {
  margin: 0 auto;
  margin-top: 10px;
  width: 100px;
  height: 32px;
  border: 1px solid #4272FC;
  border-radius: 16px;
  color: #4272FC;
  text-align: center;
  line-height: 29px;

  a {
    text-decoration: none;
    color: #4272FC;
    cursor: pointer;
    width: 100px;
    height: 32px;
    display: block;
  }
}
</style>